"use client";

import { Spacing } from "@huub-web/ui/components/Spacing";
import type { theme } from "@huub-web/ui/theme/css/theme.css";
import type { FC, Ref } from "react";

export interface SpacingTemplateProps {
  height: keyof typeof theme.spacings;
}

export const SpacingTemplate: FC<
  SpacingTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ ref, ...props }) => <Spacing ref={ref} {...props} />;
